module.exports = __webpack_public_path__ + "img/3.09cb0502.jpg";